import React, { useEffect, useState } from "react";
import BackButton from "./BackButton";
import axios from "axios";
import Swal from "sweetalert2";
import { BASE_URL } from "../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faTimes } from "@fortawesome/free-solid-svg-icons";
import "./MyCoverageModal.css"; // Import the new CSS file
import { useAuth } from "../contexts/AuthContext";

const MyCoverageModal = ({ onClose }) => {
  const { encryptedData } = useAuth(); // Use encrypted data from AuthContext
  const [coverageDetails, setCoverageDetails] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCoverageDetails = async () => {
      setLoading(true);
      try {
        const payload = {
          // member_id: localStorage.getItem("member/member_id"),
          // uid: localStorage.getItem("member/uid"),
          // updated_at: localStorage.getItem("member/updated_at"),
          // optcode: localStorage.getItem("member/optcode"),
          data: encryptedData
        };

        const formData = new FormData();
        Object.keys(payload).forEach((key) => formData.append(key, payload[key]));

        const response = await axios.post(`${BASE_URL}/x1bf/x1wh/member/coverage`, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authentication/token")}`,
          },
        });

        if (response.data.status === "success") {
          setCoverageDetails(response.data.data);
        } else {
          Swal.fire({
            title: "Error!",
            text: response.data.message,
            icon: "error",
            confirmButtonText: "OK",
            confirmButtonColor: "#ef4444",
          });
        }
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: "Failed to fetch coverage details.",
          icon: "error",
          confirmButtonText: "OK",
          confirmButtonColor: "#ef4444",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchCoverageDetails();
  }, []);

  const renderTableHeader = () => (
    <tr>
      <th>Coverage</th>
      <th>Description</th>
      <th>Covered?</th>
    </tr>
  );

  const renderTableRows = () => {
    return coverageDetails.map((coverage) => (
      <tr key={coverage.coverage_code} className={coverage.is_covered ? 'covered' : 'not-covered'}>
        <td>{coverage.coverage_code || "N/A"}</td>
        <td>{coverage.coverage_desc || "N/A"}</td>
        <td>{coverage.is_covered ? 'Yes' : 'No'}</td>
      </tr>
    ));
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <div className="modal-backrow"><BackButton onClick={onClose} /></div>
          <h1 className="modal-title">My Coverage Details</h1>
          <button onClick={onClose} className="modal-close-btn">
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="modal-body">
          {loading ? (
            <div className="loading-spinner">
              <FontAwesomeIcon icon={faSpinner} className="animate-spin" />
            </div>
          ) : (
            <div className="table-container">
              <table className="transaction-table">
                <thead>{renderTableHeader()}</thead>
                <tbody>
                  {coverageDetails.length > 0 ? (
                    renderTableRows()
                  ) : (
                    <tr>
                      <td colSpan="3" className="no-data">
                        No coverage details found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
          <div className="modal-footer">
            <button onClick={onClose} className="modal-close-text-btn">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyCoverageModal;